import MarketingSourceLogo from 'common/components/icons/marketingSourceLogo';
import Pill from 'common/components/pills/pill';
import { PillTheme } from 'common/components/pills/pill-theme';
import { useSelector } from 'react-redux';
import { selectIsIconOnly } from '../paths.slice';

interface PathPillsProps {
  sources: string[];
}

interface PathPill {
  label: string;
  count: number;
}

const createPills = (sources: string[]): PathPill[] => {
  return sources.reduce((acc: PathPill[], source: string) => {
    const existingPill = acc.find((pill) => pill.label === source);

    if (existingPill) {
      existingPill.count += 1;
    } else {
      acc.push({ label: source, count: 1 });
    }
    return acc;
  }, []);
};

export const PathPills = ({ sources }: PathPillsProps) => {
  const isIconOnly = useSelector(selectIsIconOnly);
  const pills = createPills(sources);

  return (
    <div className="flex items-center flex-wrap gap-2">
      {pills.map((pill, index) => (
        <div key={index} className="flex items-center transition-all">
          {index > 0 ? (
            <div className="flex items-center mr-2">
              <p className="relative w-4 h-3">
                <i className="ra-icons-generic-next text-xs absolute top-0 left-0 text-neutral-400"></i>
                <i className="ra-icons-generic-next text-xs absolute top-0 left-1 text-neutral-400"></i>
              </p>
            </div>
          ) : (
            <></>
          )}
          <Pill
            key={index}
            theme={
              pill.label.includes('Paid')
                ? PillTheme.SCHEDULED
                : pill.label.includes('Organic')
                ? PillTheme.SUCCESS
                : PillTheme.DISABLED
            }
            classOverrides="flex items-center mx-1 px-2 py-1"
          >
            <MarketingSourceLogo
              marketingSource={pill.label}
              iconClasses="text-xs h-4 w-4 flex items-center justify-center flex wrap"
              imageClasses="w-4 h-4 flex items-center max-w-none"
            />
            {isIconOnly ? <></> : <div className="ml-1">{pill.label}</div>}
            {pill.count > 1 ? (
              <span className="ml-1"> x{pill.count}</span>
            ) : (
              <></>
            )}
          </Pill>
        </div>
      ))}
    </div>
  );
};
